import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

// eslint-disable-next-line object-curly-newline
import { Grid, Typography, Box } from '@material-ui/core';
import axios from 'axios';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';
import updateAnalytics from '../../actions/updateAnalytics';
import DesignAndLanguages from '../../components/DesignAndLanguages';
import LogoAndStepper from '../../components/LogoAndStepper';
import TopLayer from '../../components/layers/TopLayer';
import MiddleLayer from '../../components/layers/MiddleLayer';
import BottomLayer from '../../components/layers/BottomLayer';
import ViewPortContainer from '../../components/layers/ViewPortContainer';
import TransitionButtons from '../../components/TransitionButtons';
import BoxContentContainer from '../../components/layers/BoxContentContainer';

export default function SeamlessForm() {
  // media query, on greater than iphone
  const dispatch = useDispatch();
  const restaurantId = useSelector((state) => state.formState.Restaurant_id);
  const baseURL = useSelector((state) => state.formState.baseURL);

  async function setAcknowledgement() {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    let body = {
      method: 'set',
      resource: 'restaurant',
      query: {
        _id: restaurantId,
        disabled: true,
      },
      payload: {
        'selfSignup.acknowledgedAt': { $date: new Date() },
      },
    };
    const res5 = await axios.post(
      `${baseURL}/smart-restaurant/api`,
      body,
      config
    );
    console.log('RES 5 ', res5);
  }

  return (
    <ViewPortContainer>
      <TopLayer>
        <LogoAndStepper step={4} showStepper />
      </TopLayer>
      <MiddleLayer>
        <BoxContentContainer>
          <Typography variant="h4">
            {translate('Interested in joining?')}{' '}
          </Typography>
          <ul>
            {[
              'One month free, no contract',
              'Cancel anytime, no questions asked',
              'Support rep will help you get set up',
              'You can start receiving orders as soon as possible',
            ].map((text) => {
              return (
                <li>
                  <Typography variant="h6">{translate(text)}</Typography>
                </li>
              );
            })}
          </ul>

          <br />
          <TransitionButtons
            executeLogic={setAcknowledgement}
            showBack
            showFinal
          />
        </BoxContentContainer>
      </MiddleLayer>

      <BottomLayer>
        <DesignAndLanguages />
      </BottomLayer>
    </ViewPortContainer>
  );
}
